export const APP_RESTHTTPLINK_URI = '/admin/api'
export const APP_APPCODE = 'CONSOLE'
